module.exports = __webpack_public_path__ + "img/eg.70247bdc.svg";